import React, { useEffect, useRef, useState } from "react"
import {
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  IconButton,
  Flex,
  VStack,
  DrawerFooter,
  Text,
  Box,
  background,
  BoxProps,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react"
import { BsList } from "react-icons/bs"
import { MdOutlineEventNote } from "react-icons/md"
import { FiHome } from "react-icons/fi"
import {
  RiUser6Line,
  RiUser3Line,
  RiHeart2Line,
  RiContactsLine,
  RiShoppingBag2Line,
  RiShoppingCartLine,
} from "react-icons/ri"
import { Link } from "react-router-dom"
import NavItem from "./NavItem"
import { useDispatch } from "react-redux"
import { BiLogOut, BiNews } from "react-icons/bi"
import { FaArrowsAlt } from "react-icons/fa"
import { MdCategory } from "react-icons/md"
import { useAuth } from "../../store/auth/reducer"
export default function Sidebar() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()
  const dispatch = useDispatch()
  const [ddOpen, setIsDDOpen] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  const handleDropdownToggle = () => {
    setIsDDOpen((prevState) => !prevState)
  }

  const handleClose = () => {
    onClose()
    setIsDDOpen(false)
  }
  const { busy, user } = useAuth()
  console.log(user, "userrrr or restarant admin")

  const hasPermission = (resource: any, actions: any) => {
    const resourcePermissions = user?.permission?.find(
      (p: any) => p.resource === resource
    )
    return actions.every((action: any) =>
      resourcePermissions?.action.includes(action)
    )
  }
  return (
    <>
      <IconButton
        icon={<BsList />}
        //@ts-ignore
        ref={btnRef}
        onClick={onOpen}
        top={5}
        left={5}
        bg="transparent"
        // border="1px solid black"
        position="fixed"
        zIndex={300}
        // backgroundColor={"white"}
        _hover={{ color: "white", backgroundColor: "#E24441" }}
      ></IconButton>

      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={handleClose}
        //@ts-ignore
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          {/* <DrawerCloseButton
            _focus={{ border: "none" }}
            my={1.5}
            border="none"
            // color="white"
            _hover={{
              bg: "#cb30ff",
              color: "#fff",
            }}
          /> */}
          <DrawerHeader
            borderBottomWidth="1px"
            fontWeight="bold"
            textAlign="center"
            // background={"black"}
            color="#ff6699"
          >
            <img
              src="/logo.png"
              alt="hungry tables"
              style={{ margin: "0 auto" }}
            />
          </DrawerHeader>

          <DrawerBody color="#7F7D95">
            <Flex height="100%">
              <VStack alignItems="baseline" w={"100%"}>
                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("user", ["write"]))) && (
                    <Link to="/" style={{ width: "100%" }} onClick={handleClose}>
                      <NavItem
                        logo="/icons/dashboard.svg"
                        hoveredlogo="/icons/dashboardr.svg"
                        logoalt="dashboardlogo"
                        title="Dashboard"
                        path="/"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("user", ["write"]))) && (
                    <Link
                      to="/usermanagement"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/usermanagement.svg"
                        hoveredlogo="/icons/usermanagementr.svg"
                        logoalt="usermanagementlogo"
                        title="User management"
                        path="/usermanagement"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("restaurant", ["write"]))) && (
                    <Link
                      to="/restaurantmanagement"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/restaurantmanagement.svg"
                        hoveredlogo="/icons/restaurantmanagementr.svg"
                        logoalt="restaurantmanagement"
                        title="Restaurant management"
                        path="/restaurantmanagement"
                      />
                    </Link>
                  )}
                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("discountfilter", ["write"]))) && (
                    <Link
                      to="/discountfilter"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/discount.svg"
                        hoveredlogo="/icons/discountr.svg"
                        logoalt="discountfilter"
                        title="Discount Filter"
                        path="/discountfilter"
                      />
                    </Link>
                  )}
                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("discountfilter", ["write"]))) && (
                    <Link
                      to="/email-templates"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/discount.svg"
                        hoveredlogo="/icons/discountr.svg"
                        logoalt="discountfilter"
                        title="Discount Filter"
                        path="/email-templates"
                      />
                    </Link>
                  )}
                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("restaurantsequence", ["write"]))) && (
                    <Link
                      to="/restaurantsequence"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/restaurantsequencemanagement.svg"
                        hoveredlogo="/icons/restaurantsequencemanagementr.svg"
                        logoalt="restaurantsequencemanagement"
                        title="Restaurant Sequence"
                        path="/restaurantsequence"
                      />
                    </Link>
                  )}
                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("restaurantsequence", ["write"]))) && (
                    <Link
                      to="/cuisine-management"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/restaurantsequencemanagement.svg"
                        hoveredlogo="/icons/restaurantsequencemanagementr.svg"
                        logoalt="restaurantsequencemanagement"
                        title="Cuisine Management"
                        path="/cuisine-management"
                      />
                    </Link>
                  )}
                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("dishmanagement", ["write"]))) && (
                    <Link
                      to="/dishmanagement"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/adddish.svg"
                        hoveredlogo="/icons/adddishr.svg"
                        logoalt="adddish"
                        title="Dish management"
                        path="/dishmanagement"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("slotmanagement", ["write"]))) && (
                    <Link
                      to="/slotmanagement"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/slot.svg"
                        hoveredlogo="/icons/slotr.svg"
                        logoalt="slotlogo"
                        title="Slot Management"
                        path="/slotmanagement"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("community", ["write"]))) && (
                    <Communitydropdown
                      ddOpen={ddOpen}
                      setIsHovered={setIsHovered}
                      handleDropdownToggle={handleDropdownToggle}
                      isHovered={isHovered}
                      onClose={onClose}
                      setIsDDOpen={setIsDDOpen}
                    />
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("booking", ["write"]))) && (
                    <Link
                      to="/bookingmanagement"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/bookingmanagement.svg"
                        hoveredlogo="/icons/bookingmanagementr.svg"
                        logoalt="bookingmanagementlogo"
                        title="Booking Management"
                        path="/bookingmanagement"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("marketing", ["write"]))) && (
                    <Link
                      to="/marketing"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/marketing.svg"
                        hoveredlogo="/icons/marketingr.svg"
                        logoalt="marketinglogo"
                        title="Marketing"
                        path="/marketing"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("gift", ["write"]))) && (
                    <Link
                      to="/giftcards"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/giftcards.svg"
                        hoveredlogo="/icons/giftcardsr.svg"
                        logoalt="giftcardslogo"
                        title="Gift cards"
                        path="/giftcards"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("help", ["write"]))) && (
                    <Link
                      to="/Helpcenter"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/helpcenter.svg"
                        hoveredlogo="/icons/helpcenterr.svg"
                        logoalt="helpcenterlogo"
                        title="Help center"
                        path="/Helpcenter"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("faq", ["write"]))) && (
                    <Link
                      to="/faq"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/faq.svg"
                        hoveredlogo="/icons/faqr.svg"
                        logoalt="faqlogo"
                        title="FAQ"
                        path="/faq"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("notification", ["write"]))) && (
                    <Link
                      to="/notifications"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/notification.svg"
                        hoveredlogo="/icons/notificationr.svg"
                        logoalt="notificationlogo"
                        title="Notifications"
                        path="/notifications"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("notification", ["write"]))) && (
                    <Link
                      to="/notifications-ht-celebration"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/notification.svg"
                        hoveredlogo="/icons/notificationr.svg"
                        logoalt="notificationlogo"
                        title="Notifications HT Celebration"
                        path="/notifications-ht-celebration"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("notification", ["write"]))) && (
                    <Link
                      to="/advert"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/notification.svg"
                        hoveredlogo="/icons/notificationr.svg"
                        logoalt="notificationlogo"
                        title="Advert"
                        path="/advert"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("reports", ["write"]))) && (
                    <Link
                      to="/reports"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/giftcards.svg"
                        hoveredlogo="/icons/giftcardsr.svg"
                        logoalt="reports"
                        title="Reports"
                        path="/reports"
                      />
                    </Link>
                  )}

                {(user.role === "ADMIN" ||
                  (user.role === "SUB_ADMIN" &&
                    hasPermission("credit", ["write"]))) && (
                    <Link
                      to="/creditmanagement"
                      style={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      <NavItem
                        logo="/icons/creditmanagement.svg"
                        hoveredlogo="/icons/creditmanagementr.svg"
                        logoalt="creditmanagementlogo"
                        title="Credit management"
                        path="/creditmanagement"
                      />
                    </Link>
                  )}

                {user.role === "ADMIN" && (
                  <Link
                    to="/restaurantsadmin"
                    style={{ width: "100%" }}
                    onClick={handleClose}
                  >
                    <NavItem
                      logo="/icons/restaurantmanagement.svg"
                      hoveredlogo="/icons/restaurantmanagementr.svg"
                      logoalt="srttingslogo"
                      title="Restaurant Admin"
                      path="/restaurantsadmin"
                    />
                  </Link>
                )}

                {user.role === "ADMIN" && (
                  <Link
                    to="/settings"
                    style={{ width: "100%" }}
                    onClick={handleClose}
                  >
                    <NavItem
                      logo="/icons/settings.svg"
                      hoveredlogo="/icons/settingsr.svg"
                      logoalt="srttingslogo"
                      title="Settings"
                      path="/settings"
                    />
                  </Link>
                )}
                {user.role === "RESTAURANT" && (
                  <Link
                    to="/restaurantadminbookingmanagement"
                    style={{ width: "100%" }}
                    onClick={handleClose}
                  >
                    <NavItem
                      logo="/icons/bookingmanagement.svg"
                      hoveredlogo="/icons/bookingmanagementr.svg"
                      logoalt="bookingmanagementlogo"
                      title="RBooking Management"
                      path="/restaurantadminbookingmanagement"
                    />
                  </Link>
                )}
              </VStack>
            </Flex>
          </DrawerBody>
          <DrawerFooter display="flex" justifyContent="flex-start">
            <IconButton
              icon={
                <NavItem
                  title="Sign out"
                  logo="/icons/logout.svg"
                  hoveredlogo="/icons/logout.svg"
                  logoalt="logoutlogo"
                  hoverStyles={{ bgGradient: "none" }} // Inline override to remove bgGradient
                />
              }
              aria-label="signout"
              onClick={() => {
                localStorage.clear()
                window.location.reload()
              }}
              background="none"
              border="none"
              borderRadius="none"
              _hover={{
                background: "none",
                bgGradient: "none",
              }}
              _active={{ background: "none" }}
            />
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}

const Communitydropdown = ({
  ddOpen,
  setIsHovered,
  handleDropdownToggle,
  isHovered,
  onClose,
  setIsDDOpen,
  dropdownRef,
}: any) => {
  const [isActive, setIsActive] = useState(false)
  const [iscomActive, setisComActive] = useState(false)
  const [isEveActive, setisEveActive] = useState(false)
  const shouldShowActive = isHovered || isActive

  useEffect(() => {
    const checkActive = () => {
      const currentPath = window.location.pathname
      setIsActive(
        currentPath === "/communitymanagement" ||
        currentPath === "/eventmanagement"
      )

      setisComActive(currentPath === "/communitymanagement")
      setisEveActive(currentPath === "/eventmanagement")
    }

    checkActive()

    window.addEventListener("popstate", checkActive)
    return () => window.removeEventListener("popstate", checkActive)
  }, [])

  return (
    <Flex mt={1} flexDir="column" w="100%" alignItems="flex-start">
      <Menu placement="right">
        <Box
          p="12px 16px"
          w="100%"
          borderRadius={ddOpen ? "10px" : "132px"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          _hover={{
            color: "#212121",
            bgGradient:
              "linear(90deg, rgba(226, 68, 65, 0.10) 0.07%, rgba(226, 68, 65, 0.00) 99.94%)",
          }}
          bgGradient={
            isActive
              ? "linear(90deg, rgba(226, 68, 65, 0.10) 0.07%, rgba(226, 68, 65, 0.00) 99.94%)"
              : "none"
          }
          color={isActive ? "#212121" : "#757575"}
        >
          <MenuButton w="100%" onClick={handleDropdownToggle}>
            <Flex justifyContent="space-between" w="100%" alignItems="center">
              <Flex alignItems="center">
                <img
                  src={
                    !shouldShowActive
                      ? "/icons/community.svg"
                      : "/icons/communityr.svg"
                  }
                  alt="Community Logo"
                  style={{ width: "24px", height: "24px" }}
                />
                <Text ml={5}>Community</Text>
              </Flex>

              <img
                src="/icons/dropdownarrow.svg"
                alt="Dropdown Arrow"
                style={{
                  transform: ddOpen ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            </Flex>
          </MenuButton>

          {ddOpen && (
            <Box mt="12px" w="100%">
              <Link
                to="/communitymanagement"
                style={{ width: "100%" }}
                onClick={() => {
                  onClose()
                  setIsDDOpen(false)
                  setIsHovered(false)
                }}
              >
                <Flex
                  cursor="pointer"
                  borderRadius="132px"
                  p="12px 16px"
                  color={iscomActive ? "#212121" : "#757575"}
                  mb="8px"
                  _hover={{ bg: "#fff", color: "#212121" }}
                  bg={iscomActive ? "#fff" : "none"}
                >
                  Community management
                </Flex>
              </Link>
              <Link
                to="eventmanagement"
                style={{ width: "100%" }}
                onClick={() => {
                  onClose()
                  setIsDDOpen(false)

                  setIsHovered(false)
                }}
              >
                <Flex
                  cursor="pointer"
                  borderRadius="132px"
                  p="12px 16px"
                  color={isEveActive ? "#212121" : "#757575"}
                  _hover={{ bg: "#fff", color: "#212121" }}
                  bg={isEveActive ? "#fff" : "none"}
                >
                  Event management
                </Flex>
              </Link>
            </Box>
          )}
        </Box>
      </Menu>
    </Flex>
  )
}
